<template>
<el-form ref="form" :model="form" label-width="200px" style="margin:20px;width:60%;min-width:600px;">
    <el-form-item label="所有数据每天">
        <el-time-select v-model="form.syntime" :picker-options="{ start: '00:00',step: '00:60',end: '23:00'}" placeholder="请选择时间">
        </el-time-select>
        开始同步更新(<span style="color:red">*尽量选择系统闲时，比如:凌晨1点</span>) 
    </el-form-item>
	<el-form-item><el-button type="primary" @click.native="save">保存</el-button></el-form-item>
	<el-divider></el-divider>
    <el-form-item label="河北九城数据">
        <el-time-select v-model="form.syntime_hebeijiucheng" :picker-options="{ start: '00:00',step: '00:60',end: '23:00'}" placeholder="请选择时间">
        </el-time-select>
        开始同步更新(<span style="color:red">*尽量选择系统闲时，比如:凌晨3点</span>) 
    </el-form-item>
	<el-form-item><el-button type="primary" @click.native="save_hebeijiucheng">保存</el-button></el-form-item>
</el-form>
</template>

<script>
import util from '../../common/js/util'
import {
    getSynTime,
    setSynTime,
    getSynTime_hebeijiucheng,
    setSynTime_hebeijiucheng
} from '../../api/api';

export default {
    data() {
        return {
            form: {
                syntime: '',
                syntime_hebeijiucheng: ''
            }
        }
    },
    methods: {
        save() {
            if ('' === this.form.syntime) {
                this.$message({
                    message: '请输入每天数据同步的时间点',
                    type: 'error'
                });
                return;
            }
            let para = Object.assign({}, this.form);
            console.log("para.syntime:" + para.syntime);
            setSynTime(para).then((res) => {
                let {
                    msg,
                    code
                } = res;
                if (code !== 0) {
                    this.$message({
                        message: "设置失败",
                        type: 'error'
                    });
                } else {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                }
            });
        },
        save_hebeijiucheng() {
            if ('' === this.form.syntime_hebeijiucheng) {
                this.$message({
                    message: '请输入每天数据同步的时间点',
                    type: 'error'
                });
                return;
            }
			let para = {
				syntime:this.form.syntime_hebeijiucheng
			};
            setSynTime_hebeijiucheng(para).then((res) => {
                let {
                    msg,
                    code
                } = res;
                if (code !== 0) {
                    this.$message({
                        message: "设置失败",
                        type: 'error'
                    });
                } else {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                }
            });
        }

    },
    mounted() {
		console.log("域名："+window.location.hostname);
        let para = {};
        getSynTime(para).then((res) => {
            this.form.syntime = res.data;
        });
        getSynTime_hebeijiucheng(para).then((res) => {
            this.form.syntime_hebeijiucheng = res.data;
        });
    }

}
</script>



// WEBPACK FOOTER //
// set_update.vue?76736b71